<template>
  <div class="wrapper">
    <div v-for="organization in this.organizations">
      <router-link :to="{ name: 'organization_edit', params: { id: organization[0] }}">
        <h3 class="title--link">
          {{ organization[0] }} - {{ organization[1] }}
        </h3>
      </router-link>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    organizations: {
      type: Array
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

.title--link {
  color: #0000EE;
}
</style>



// WEBPACK FOOTER //
// PlanOrganizationList.vue?2918599a